import { withPopup } from '../lib/popup';

import ProjectMembershipsStep from './ProjectMembershipsStep';

export default withPopup(ProjectMembershipsStep);
